export default {
  loading: false,
  form: {
    warehouses: [],
    logisticProviders: [],
    dateRange: 'D1',
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-recon/features/analytics/components/analytics-filters/store/states.js